import { useAppLock, WelcomeScreen, SetupScreen, LockScreen } from '@/components/AppLock';
import App from './App';

export function AppGate(): JSX.Element | null {
  const {
    isUnlocked,
    isConfigured,
    lock,
    isEnabled,
    decision,
    skipEncryption,
    enableEncryption,
  } = useAppLock();

  if (decision === 'pending') {
    return <WelcomeScreen onEnable={enableEncryption} onSkip={skipEncryption} />;
  }

  if (isEnabled && !isConfigured) {
    return (
      <SetupScreen
        onSubmit={async (password) => {
          if (!lock) return;
          await lock.setup(password);
        }}
        onSkip={skipEncryption}
      />
    );
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return (
      <LockScreen
        onUnlock={async (password) => {
          if (!lock) return false;
          return lock.unlock(password);
        }}
      />
    );
  }

  if (!isUnlocked) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }} role="status" aria-label="Loading application">
        <p style={{ color: 'var(--amg-text-muted, #6b7280)', fontFamily: 'system-ui, sans-serif' }}>Loading…</p>
      </div>
    );
  }

  return <App />;
}
